import { render, staticRenderFns } from "./FollowInterests.vue?vue&type=template&id=601038f1&"
import script from "./FollowInterests.vue?vue&type=script&lang=js&"
export * from "./FollowInterests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports